import { useEffect } from "react";
import { LegalPage } from "@/components/landing/LegalPage";

export default function Agb() {
  useEffect(() => {
    document.title = "AGB — Positivup";
  }, []);
  return <LegalPage doc="agb" />;
}
